import type { ResumeDto } from "@stylingcv/dto";
import { defaultResumeData } from "@stylingcv/schema";

/** sessionStorage: HTML to inject into builder Summary when coming from AI tools */
export const PENDING_SUMMARY_STORAGE_KEY = "stylingcv.pendingSummaryFromTool";

/** sessionStorage: show toast once after pending summary was merged into resume */
export const PENDING_SUMMARY_SHOW_TOAST_KEY = "stylingcv.pendingSummaryShowToast";

/** Plain API text → safe HTML for TipTap summary (paragraphs) */
export function plainTextToSummaryHtml(text: string): string {
  const escaped = text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
  const paragraphs = escaped
    .split(/\n+/)
    .map((p) => p.trim())
    .filter(Boolean);
  if (paragraphs.length === 0) return "<p></p>";
  return paragraphs.map((p) => `<p>${p}</p>`).join("");
}

/**
 * If the user opened the builder from the summary tool, merge stored HTML into Summary
 * and clear storage. Sets a flag so the builder can toast once.
 */
export function applyPendingSummaryToResumeDto(resume: ResumeDto): ResumeDto {
  if (typeof window === "undefined") return resume;
  const html = sessionStorage.getItem(PENDING_SUMMARY_STORAGE_KEY);
  if (!html) return resume;

  sessionStorage.removeItem(PENDING_SUMMARY_STORAGE_KEY);
  sessionStorage.setItem(PENDING_SUMMARY_SHOW_TOAST_KEY, "1");

  const baseSummary = resume.data?.sections?.summary ?? defaultResumeData.sections.summary;

  return {
    ...resume,
    data: {
      ...resume.data,
      sections: {
        ...defaultResumeData.sections,
        ...resume.data.sections,
        summary: {
          ...baseSummary,
          content: html,
        },
      },
    },
  };
}
